module.exports = __webpack_public_path__ + "static/images/fenxiang_ic@2x.png";